module.exports = __webpack_public_path__ + "media/images/high_rise_building-95f9d05dcfe87167ce5d137c7422dd8b.png";